var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appLoader"},[_c('shell-image',{ref:"logo",staticClass:"appLoader__image",attrs:{"sources":[
      {
        srcset: '/images/i-love-bio-logo.png',
        media: '(min-width: 200px)',
        type: 'image/png',
      } ]}}),_c('h1',[_vm._v("Chargement...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }